import { SvgIconComponent } from '@mui/icons-material';
import {
  IconButton as MuiIconButton,
  IconButtonProps as MuiIconButtonProps,
  SvgIconProps,
} from '@mui/material';
import React from 'react';

export interface IconButtonProps extends Omit<MuiIconButtonProps, 'children'> {
  icon: SvgIconComponent;
  fontSize?: SvgIconProps['fontSize'];
  width?: SvgIconProps['width'];
  id?: string;
}

const IconButton = (props: IconButtonProps) => {
  const { icon: Icon, fontSize, width, sx, id, ...restProps } = props;

  return (
    <MuiIconButton id={id} {...restProps}>
      <Icon fontSize={fontSize} sx={{ width: `${width ? width : 'unset'} !important`}}/>
    </MuiIconButton>
  );
};

export default IconButton;
